import styles from './style.module.scss';
import classnames from 'classnames';

const CurShowCard = ({ item, itemIndex, activeIndex, onTabChange }) => {
  return (
    <div
      key={item.title}
      onMouseEnter={onTabChange}
      className={classnames({
        [styles['header-item']]: true,
        [styles['header-item-active']]: activeIndex === itemIndex,
      })}
    >
      {item.title}
    </div>
  );
};

export default CurShowCard;
